/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetGameMinecraftServerstatusRequest = { server: string };

export const GetGameMinecraftServerstatusRequest$zodSchema: z.ZodType<
  GetGameMinecraftServerstatusRequest
> = z.object({
  server: z.string().describe(
    "Minecraft服务器的地址，可以是域名（如 `hypixel.net`）或 `IP:端口` 的形式（如 `mc.example.com:25565`）。如果省略端口，将默认使用 `25565`。",
  ),
});

export type GetGameMinecraftServerstatusBadGatewayDetails = {};

export const GetGameMinecraftServerstatusBadGatewayDetails$zodSchema: z.ZodType<
  GetGameMinecraftServerstatusBadGatewayDetails
> = z.object({});

/**
 * 查询失败。在尝试连接并获取服务器信息时发生网络错误或协议错误。
 */
export type GetGameMinecraftServerstatusBadGatewayResponseBody = {
  code?: string | undefined;
  details?: GetGameMinecraftServerstatusBadGatewayDetails | undefined;
  message?: string | undefined;
};

export const GetGameMinecraftServerstatusBadGatewayResponseBody$zodSchema:
  z.ZodType<GetGameMinecraftServerstatusBadGatewayResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() =>
      GetGameMinecraftServerstatusBadGatewayDetails$zodSchema
    ).optional(),
    message: z.string().optional(),
  }).describe("查询失败。在尝试连接并获取服务器信息时发生网络错误或协议错误。");

export type GetGameMinecraftServerstatusNotFoundDetails = {};

export const GetGameMinecraftServerstatusNotFoundDetails$zodSchema: z.ZodType<
  GetGameMinecraftServerstatusNotFoundDetails
> = z.object({});

/**
 * 服务器未找到。这可能意味着你提供的服务器地址无法解析，或者服务器当前处于离线状态。
 */
export type GetGameMinecraftServerstatusNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetGameMinecraftServerstatusNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetGameMinecraftServerstatusNotFoundResponseBody$zodSchema:
  z.ZodType<GetGameMinecraftServerstatusNotFoundResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetGameMinecraftServerstatusNotFoundDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe(
    "服务器未找到。这可能意味着你提供的服务器地址无法解析，或者服务器当前处于离线状态。",
  );

export type GetGameMinecraftServerstatusBadRequestDetails = {};

export const GetGameMinecraftServerstatusBadRequestDetails$zodSchema: z.ZodType<
  GetGameMinecraftServerstatusBadRequestDetails
> = z.object({});

/**
 * 请求失败。请检查你是否提供了 `server` 参数。
 */
export type GetGameMinecraftServerstatusBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetGameMinecraftServerstatusBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetGameMinecraftServerstatusBadRequestResponseBody$zodSchema:
  z.ZodType<GetGameMinecraftServerstatusBadRequestResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() =>
      GetGameMinecraftServerstatusBadRequestDetails$zodSchema
    ).optional(),
    message: z.string().optional(),
  }).describe("请求失败。请检查你是否提供了 `server` 参数。");

/**
 * 查询成功！返回服务器的详细状态信息。
 */
export type GetGameMinecraftServerstatusResponseBody = {
  favicon_url?: string | undefined;
  ip?: string | undefined;
  max_players?: number | undefined;
  motd_clean?: string | undefined;
  motd_html?: string | undefined;
  online?: boolean | undefined;
  players?: number | undefined;
  port?: number | undefined;
  version?: string | undefined;
};

export const GetGameMinecraftServerstatusResponseBody$zodSchema: z.ZodType<
  GetGameMinecraftServerstatusResponseBody
> = z.object({
  favicon_url: z.string().optional(),
  ip: z.string().optional(),
  max_players: z.int().optional(),
  motd_clean: z.string().optional(),
  motd_html: z.string().optional(),
  online: z.boolean().optional(),
  players: z.int().optional(),
  port: z.int().optional(),
  version: z.string().optional(),
}).describe("查询成功！返回服务器的详细状态信息。");

export type GetGameMinecraftServerstatusResponse =
  | GetGameMinecraftServerstatusResponseBody
  | GetGameMinecraftServerstatusBadRequestResponseBody
  | GetGameMinecraftServerstatusNotFoundResponseBody
  | GetGameMinecraftServerstatusBadGatewayResponseBody;

export const GetGameMinecraftServerstatusResponse$zodSchema: z.ZodType<
  GetGameMinecraftServerstatusResponse
> = z.union([
  z.lazy(() => GetGameMinecraftServerstatusResponseBody$zodSchema),
  z.lazy(() => GetGameMinecraftServerstatusBadRequestResponseBody$zodSchema),
  z.lazy(() => GetGameMinecraftServerstatusNotFoundResponseBody$zodSchema),
  z.lazy(() => GetGameMinecraftServerstatusBadGatewayResponseBody$zodSchema),
]);
